import { render, staticRenderFns } from "./UpdateBarometerButton.vue?vue&type=template&id=1fc1849f"
import script from "./UpdateBarometerButton.vue?vue&type=script&lang=ts"
export * from "./UpdateBarometerButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports